/**
 * Admin Ticket Statistics Page
 *
 * Statistics now live as a tab on /tickets (see TicketStatistics + ModeratorTicketsPage). This
 * route is kept alive only so old links/bookmarks to /tickets/statistics still land somewhere.
 */

import { Navigate } from 'react-router-dom'

export default function AdminTicketStatisticsPage() {
  return <Navigate to="/tickets?tab=statistics" replace />
}
